import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import {
  ProjectCategoryDto,
  ClusterDto,
  StateDto,
  LgaDto,
  CommunityDto,
  ClusterCommunityDto,
} from '@cradua/data';

@Component({
  selector: 'mrsoftapps-cluster-community-view',
  templateUrl: './cluster-community-view.component.html',
  styleUrls: ['./cluster-community-view.component.css'],
})
export class ClusterCommunityViewComponent implements OnInit {
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() clusters: ClusterDto[];
  @Input() clusterCommunities: ClusterCommunityDto[];
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() communities: CommunityDto[];
  clusterCommunityForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();

  clusterCommunityArrayForm: FormGroup;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredClusterCommunity: Array<any> = [];
  status: boolean;
  selectedGMOUId: any;
  selectedClusterId: any;
  filteredCommunity: CommunityDto[];
  newObject: any;
  showAdd: boolean;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.clusterCommunityForm = this.fb.group({
      ClusterCommunityName: [''],
      GMOUId: [''],
      ClusterId: ['', Validators.required],
      CommunityId: ['', Validators.required],
      StateId: [''],
      LgaId: ['', Validators.required],
      id: null,
    });

    this.clusterCommunityArrayForm = this.fb.group({
      ClusterCommunities: this.fb.array([]),
    });
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  setClusterCommunity(value) {
    const control = this.clusterCommunityArrayForm.controls
      .ClusterCommunities as FormArray;
    value.forEach((item) => {
      control.push(
        this.fb.group({
          ClusterCommunityName: item.ClusterCommunityName,
          GMOUId: item.GMOUId,
          ClusterId: item.ClusterId,
          CommunityId: item.CommunityId,
          StateId: item.StateId,
          LgaId: item.LgaId,
          id: item.id,
        })
      );
    });
  }

  addClusterCommunity(value) {
    this.newObject = Object.assign([], this.filteredClusterCommunity);
    const itemFound = this.clusterCommunityArrayForm.value.ClusterCommunities.find(
      (item) =>
        item.CommunityId.trim().toLowerCase() ===
        value.CommunityId.trim().toLowerCase()
    );
    let alertMessage: string;

    if (!itemFound) {
      const control = this.clusterCommunityArrayForm.controls
        .ClusterCommunities as FormArray;
      control.insert(
        0,
        this.fb.group({
          ClusterCommunityName: value.ClusterCommunityName,
          GMOUId: value.GMOUId,
          ClusterId: value.ClusterId,
          CommunityId: value.CommunityId,
          StateId: value.StateId,
          LgaId: value.LgaId,
          id: value.id,
        })
      );
    } else {
      alertMessage = 'already exist, please add a different community!';
      Swal.fire(
        'Warning!',

        this.StakeHolderAlertMessage(alertMessage),
        'warning'
      );
    }
  }

  selectedLga(event) {
    this.filteredCommunity = this.communities.filter((s) => s.LgaId === event);
  }

  getCommunityName(id) {
    return this.communities.find((item) => item.id === id).CommunityName;
  }
  // method to filter state
  selectCluster(event: string) {
    this.filteredClusterCommunity = this.clusterCommunities.filter(
      (s) => s.ClusterId === event
    );
    console.log('found cluster ', this.filteredClusterCommunity);
    this.selectedClusterId = event;
    this.setClusterCommunity(this.filteredClusterCommunity);
    // const control = this.clusterCommunityForm.controls.ClusterCommunities as FormArray;
    // this.filteredClusterCommunity = findCluster.map(item => {
    //   return {
    //     ClusterCommunityName: item.ClusterCommunityName,
    //   GMOUId: item.GMOUId,
    //   ClusterId: item.ClusterId,
    //   CommunityId: this.getCommunityName(item.CommunityId),
    //   StateId: item.StateId,
    //   LgaId: item.LgaId,
    //   id: item.id
    //   }
    // })
    if (this.filteredClusterCommunity.length > 0) {
      this.status = true;
      // this.clearFormArray(control);
      // this.setCluster();
    } else {
      this.status = true;
      // this.clearFormArray(control);
    }
  }

  // method to add Country
  // addCluster() {
  // 	const control = this.clusterCommunityArrayForm.controls.ClusterCommunities as FormArray;
  // 	control.insert(
  // 		0,
  // 		this.fb.group({
  // 			ClusterCommunityName: [ '', Validators.required ],
  //       ProjectCategoryId: [''],
  //       ClusterId: [''],
  // 			CommunityId: [''],
  // 			StateId: [''],
  // 			LgaId: [''],
  // 			id: null
  // 		})
  // 	);
  // }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list

  deleteCluster(index: number, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.clusterCommunityArrayForm.controls
          .ClusterCommunities as FormArray;
        control.removeAt(index);
        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
          console.log('control ', this.filteredDelete);
          // this.filteredDelete.unshift('clusterCommunity');
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  getState(id) {
    const selectedLga = this.lgas.find((item) => item.id === id);

    if (!selectedLga) {
      return;
    }

    const selectedState = this.states.find(
      (item) => item.id === selectedLga.StateId
    );

    if (!selectedState) {
      return;
    }

    return selectedState;
  }

  getProjectCategory(id) {
    const selectedType = this.clusters.find((item) => item.id === id);
    if (!selectedType) {
      return;
    }

    const selectedCategory = this.projectCategories.find(
      (item) => item.id === selectedType.ProjectCategoryId
    );

    if (!selectedCategory) {
      return;
    }

    return selectedCategory;
  }

  getCommunityDuplicateName(id) {
    const foundCommunity = this.clusterCommunities.find(
      (item) => item.CommunityId === id
    );

    return foundCommunity;
  }

  StakeHolderAlertMessage(message) {
    return `
      <div style="color:#04012d; font-size: 16px; margin: 2px;">
      </div>
      <div>
      ${message}
      </div>
      `;
  }

  saveClusterCommunity() {
    this.newObject = this.clusterCommunityArrayForm.value;
    console.log('cluster community ', this.filteredDelete);

    const updateValue = {
      ClusterCommunities: this.newObject.ClusterCommunities,
      type: 'clusterCommunity',
    };

    this.changeEmit.emit(updateValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('clusterCommunity');
      console.log('sub ', this.filteredDelete);
      this.deleteEvent.emit(this.filteredDelete);
    }

    // if (this.filteredDelete.length !== 0) {

    //   this.deleteEvent.emit(this.filteredDelete);
    // }
    // this.onSaveProjectStakeholder.emit(this.newObject);
    // this.searchStakeholderValue = null;
  }

  selectedComm() {
    this.showAdd = true;
  }

  onSubmit(formValue: any) {
    // const foundCommunity = this.getCommunityDuplicateName(formValue.CommunityId);

    // let alertMessage;
    // if(foundCommunity) {
    //   alertMessage = 'already exist, please add a different community!';
    //   Swal.fire(
    //     'Warning!',

    //     this.StakeHolderAlertMessage(alertMessage),
    //     'warning'
    //   )
    // } else {

    const selectedState = this.getState(formValue.LgaId);
    const selectedCluster = this.getProjectCategory(formValue.ClusterId);
    formValue.StateId = selectedState.id;
    formValue.GMOUId = selectedCluster.ProjectCategoryId;

    // formValue.type = 'clusterCommunity';
    let data = [];
    data.push(formValue);

    this.addClusterCommunity(formValue);

    //   const updateValue = {
    //     ClusterCommunities: data,
    //     type:'clusterCommunity'
    //   }
    //  console.log('sub ',updateValue)
    //   this.changeEmit.emit(updateValue);
    //   if (this.filteredDelete.length !== 0) {
    //     this.filteredDelete.unshift('clusterCommunity');
    //     this.deleteEvent.emit(this.filteredDelete);
    //   }

    // }
  }
}
